import React, { useState, useEffect, useRef } from "react";
import AdminAppBar from "../../../adminComponents/AdminAppBar";

import { ToastContainer } from "react-toastify";
import { IoSearch } from "react-icons/io5";
import { MdFilterListAlt } from "react-icons/md";

import { leadStatusMap, statusIcons } from "../../../../Enum";
import {
  interestLevel,
  getStatusBgColor,
} from "../../../../Enum/LeadEnumConstants";
import { FaChevronDown } from "react-icons/fa";
import Select, { components } from "react-select";
import teamService from "../../../Services/TeamService";

import LeadTable from "../../../Form/LeadTable/LeadTable";
import LeadDbService from "../../../Services/LeadDbService";

import { useLocation, useNavigate } from "react-router-dom";
// import ReasignModal from "./ReasignModel";
import {
  showErrorToast,
  showInfoToast,
  showSuccessToast,
} from "../../../Constant/Notification";
import { department, teamIds, teamList } from "../../../../utils/storage";

import CustomHeading from "../../../common/CustomHeading";
import { getBasePathByUserRole } from "../../../../utils/roleRoutes";

import CustomTruncatedText from "../../../common/CustomTruncatedText";
import { formatToIndianDate } from "../../../../utils/dateFormatter";
import { status } from "../../../../Enum/LeadEnumConstants";
import CustomButton from "../../../common/CustomButton";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import Loader from "../../../Constant/Loader";
import CallLogsSummaryFilter from "./CallLogsSummaryFilter";
import CallLogService from "../../../Services/CallLogService";
import {
  Search,
  Filter,
  Download,
  X,
  Phone,
  Clock,
  Users,
  BarChart3,
  ChevronDown,
  Calendar,
  User,
  Building2,
} from "lucide-react";
import { features } from "../../../../config/featureConfig";
import UserService from "../../../../GlobalSetupComponents/Services/UserService";
import {
  managementDepartmentLabel,
  salesDepartmentLabel,
} from "../../../../GlobalSetupComponents/Enum/DepartmentEnum";

const CallLogsSummaryList = () => {
  const location = useLocation();
  console.log(location.state);

  // User Info to user id and team Id

  const userId = location.state?.userId || null;
  const teamId = location.state?.teamId || null;
  const filterOpen = location.state?.filterOpen;

  console.log(
    "Team Id",
    Array.isArray(teamIds) && teamIds.length > 0 ? teamIds[0] : "No teamId"
  );

  const defaultTeamId =
    Array.isArray(teamIds) && teamIds.length > 0 ? teamIds[0] : teamId;

  const [filterVisible, setFilterVisible] = useState(filterOpen || false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [leadSource, setLeadSource] = useState([]);

  const [optionLocation, setOptionLocation] = useState([]);
  const [leadSources, setLeadSources] = useState([]);
  const [teams, setTeams] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(userId || null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState(defaultTeamId || null);
  const todayDate = new Date();
  const [startDate, setStartDate] = useState(
    todayDate.toISOString().split("T")[0]
  );
  const [endDate, setEndDate] = useState(todayDate.toISOString().split("T")[0]);
  const [startTime, setStartTime] = useState("00:00");
  const [endTime, setEndTime] = useState("23:59");
  const [startType, setStartType] = useState("text");
  const [endType, setEndType] = useState("text");
  const [searchQuery, setSearchQuery] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [leads, setLeads] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [nextPageToken, setNextPageToken] = useState(null);
  const [prevPageToken, setPrevPageToken] = useState(null);
  const [hasMoreLeads, setHasMoreLeads] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [leadCache, setLeadCache] = useState({});
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const userRole = userData?.user?.role;
  const [showReassignModal, setShowReassignModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [teamToggle, setTeamToggle] = useState(true);
  const [selectedLeadSourceId, setSelectedLeadSourceId] = useState(null);
  const [attentStatus, setAttentStatus] = useState(null);
  const [duration, setDuration] = useState(null);

  const [isIVR, setIsIVR] = useState(false);
  const [callStatus, setCallStatus] = useState(null);

  // Add state for call summary statistics
  const [totalCount, setTotalCount] = useState(0);
  const [overallCallCount, setOverallCallCount] = useState(0);
  const [totalCallDuration, setTotalCallDuration] = useState(
    "0 H : 0 Min : 0 Sec"
  );

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "transparent",
      border: "none",
      boxShadow: "none",
    }),
  };

  const getBackgroundClass = (label) => {
    switch (label.toLowerCase()) {
      case "gold":
        return "bg-gradient-to-b from-[#FFB947] to-[#ECCD90] bg-clip-text text-transparent";
      case "silver":
        return "bg-gradient-to-b from-[#B6B6B6] to-[#E8E8E8] bg-clip-text text-transparent";
      case "bronze":
        return "bg-gradient-to-b from-[#BA7E5E] via-[#FF9F6B] to-[#411904] bg-clip-text text-transparent";
      case "diamond":
        return "bg-gradient-to-b from-[#0563FF] to-[#4085F8] bg-clip-text text-transparent";
      default:
        return "text-black";
    }
  };

  const handleLeadInfo = (lead) => {
    console.log("Lead object:", lead);
    console.log("Lead ID:", lead.leadDocId);
    let path = "";
    if (userRole === "Admin") {
      path = `/admin/lead-info/${lead.leadDocId}`;
    } else if (userRole === "CMO") {
      path = `/cmo/lead-info/${lead.leadDocId}`;
    } else if (userRole === "MD") {
      path = `/md/lead-info/${lead.leadDocId}`;
    } else if (userRole === "BOD") {
      path = `/bod/lead-info/${lead.leadDocId}`;
    }
    navigate(path, { state: { lead } });
  };

  const baseColumns = [
    {
      key: "leadName",
      title: "Name",
      render: (text, record) => (
        <div
          onClick={() => handleLeadInfo(record)}
          title={text}
          className="text-blue-500 line-clamp-2 capitalize truncate cursor-pointer text-center"
        >
          {text}
        </div>
      ),
    },
    {
      key: "phoneNumber",
      title: "Phone Number",
      render: (text, record) => (
        <div className="text-center truncate">{record.phoneNumber}</div>
      ),
    },
    {
      key: "leadStatus",
      title: "Status",
      render: (value) => {
        const matchedStatus = statusIcons.find((item) => item.label === value);
        if (!matchedStatus)
          return (
            <span className="text-gray-600 text-center block">Unknown</span>
          );

        return (
          <div
            className={`${getStatusBgColor(
              matchedStatus?.label
            )} flex justify-center items-center gap-2 text-center rounded-full`}
          >
            <img
              src={matchedStatus.image}
              alt={matchedStatus.label}
              className="w-5 h-5"
            />
            <span className="text-gray-700">{matchedStatus.label}</span>
          </div>
        );
      },
    },
    {
      key: "callMadeTimestamp",
      title: "Call Date & Time",
      render: (value) => <div className="text-center">{value}</div>,
    },
    {
      key: "callDuration",
      title: "Duration",
      render: (value) => (
        <div title={value} className="truncate text-center cursor-pointer">
          {value}
        </div>
      ),
    },
    {
      key: "callType",
      title: "Call Status",
      render: (value) => {
        const formattedValue =
          value?.toLowerCase() === "outgoing"
            ? "Outgoing"
            : value?.toLowerCase() === "incoming"
            ? "Incoming"
            : value?.toLowerCase() === "missed"
            ? "Missed"
            : value?.toLowerCase() === "dialed"
            ? "RNR Calls"
            : value;

        const colorClass =
          value?.toLowerCase() === "outgoing"
            ? "text-green-500"
            : value?.toLowerCase() === "incoming"
            ? "text-blue-500"
            : value?.toLowerCase() === "missed"
            ? "text-red-500"
            : "text-gray-500";

        return (
          <div
            title={formattedValue}
            className={`truncate text-center cursor-pointer ${colorClass}`}
          >
            {formattedValue}
          </div>
        );
      },
    },
  ];

  if (isIVR) {
    baseColumns.push({
      key: "callRecordUrl",
      title: "IVR Recording",
      render: (value, record) => {
        if (!record.callRecordUrl) {
          return (
            <span className="text-gray-400 text-center">No Recording</span>
          );
        }
        return (
          <div className="flex justify-center">
            <audio src={record.callRecordUrl} controls className="" />
          </div>
        );
      },
    });
  }

  const columns = baseColumns;

  const formatDate = (date) => {
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const year = d.getFullYear();
    return `${month}-${day}-${year}`;
  };

  const formattedStartDate = startDate ? formatDate(startDate) : "";
  const formattedEndDate = endDate ? formatDate(endDate) : "";

  const removalCountRef = useRef(0);

  console.log("Formatted Start Date:", startTime, endTime);

  const applyFilter = (removalChip) => {
    if (startDate && !endDate) {
      showErrorToast("End Date is required when Start Date is selected.");
      return;
    }
    if(!selectedTeam)
    {
      showErrorToast("Please select a Team");
      return;
    }
    if(!selectedUser)
    {
      showErrorToast("Please select a User");
      return;
    }

    console.log("applyFilter", removalChip);

    // Compute what the new state will be after the chip is removed
    const level = removalChip === "quality" ? null : selectedLevel;
    const status = removalChip === "status" ? null : callStatus;
    const location = removalChip === "location" ? null : leadSource;
    const team = removalChip === "team" ? null : selectedTeam;
    const user = removalChip === "user" ? null : selectedUser;
    const start = removalChip === "startDate" ? null : formattedStartDate;
    const end = removalChip === "startDate" ? null : formattedEndDate;

    if (teamToggle) {
      const noFiltersSelected =
        !level &&
        !status &&
        (!location || location.length === 0) &&
        !team &&
        !user &&
        !start &&
        !end;

      if (noFiltersSelected) {
        showInfoToast("No filters selected. Please apply at least one.");

        setLeads([]);
        setHasMoreLeads(false);
        setLeadCache({});
        return;
      }
    }

    const newPageSize = 10;
    setLeadCache({});

    handleApplyFilter(null, "reset", newPageSize, 1, removalChip);
  };

  const handleApplyFilter = async (
    pageToken = null,
    direction = "next",
    limitOverride = null,
    overridePage = null,
    removalChip
  ) => {
    setLoading(true);
    console.log("handleApplyFilter", removalChip);
    try {
      let targetPage = overridePage ?? currentPage;

      if (direction === "next") {
        targetPage += 1;
      } else if (direction === "previous") {
        targetPage = Math.max(targetPage - 1, 1);
      } else if (direction === "reset") {
        targetPage = 1;
      }

      if (leadCache[targetPage] && !removalChip) {
        const cached = leadCache[targetPage];
        setLeads(cached.leads);
        setNextPageToken(cached.next);
        setPrevPageToken(cached.prev);
        setHasMoreLeads(!!cached.next);
        setCurrentPage(targetPage);
        return;
      }
      if (removalChip === "user") {
        setSelectedUser(userId || null);
      }

      const body = {
        searchKey: searchQuery || null,
        //  status: removalChip == "status" ? null : selectedStatus || null,
        //  quality: removalChip == "quality" ? null : selectedLevel?.label || null,
        //   location: removalChip == "location" ? null : leadSource?.value || null,
        // teamId: removalChip == "team" ? null : selectedTeam || defaultTeamId,
        //     teamStatus: teamToggle,
        //   leadSourceId: leadSource?.value || null,

        userId: removalChip == "user" ? userId : selectedUser || null,
        startDate:
          removalChip == "startDate" ? null : formattedStartDate || null,
        isIvr: isIVR,
        endDate: removalChip == "startDate" ? null : formattedEndDate || null,
        startTime: removalChip == "startDate" ? null : startTime || null,
        endTime: removalChip == "startDate" ? null : endTime || null,
        callType: removalChip == "status" ? null : callStatus || null,
        attendanceFilter: removalChip == "attend" ? null : attentStatus || null,
        durationFilter: removalChip == "duration" ? null : duration || null,
        limit: limitOverride ?? pageSize,
        next: direction === "next" ? pageToken : null,
        previous: direction === "previous" ? pageToken : null,
        direction,
      };

      const filterData = await CallLogService.getCallLogSummary(body);
      const newLeads = filterData.data.callLogs;
      const newNext = filterData.data.next;
      const newPrev = filterData.data.previous;

      // Update total count and summary statistics
      setTotalCount(filterData.data.totalCount || 0);
      setOverallCallCount(filterData.data.overallCallCount || 0);
      setTotalCallDuration(
        filterData.data.totalCallDuration || "0 H : 0 Min : 0 Sec"
      );

      setLeadCache((prev) => ({
        ...prev,
        [targetPage]: {
          leads: newLeads,
          next: newNext,
          prev: newPrev,
        },
      }));

      setFilterVisible(false);
      setLeads(newLeads);
      setNextPageToken(newNext);
      setPrevPageToken(newPrev);
      setHasMoreLeads(!!newNext);
      setCurrentPage(targetPage);
    } catch (error) {
      console.error("Error fetching filtered leads:", error);
      showErrorToast(error?.response?.data?.message || "Error fetching leads");
    } finally {
      setLoading(false);
    }
  };

  const isFirstRender = useRef(true);

  useEffect(() => {
    handleApplyFilter(null, "reset", pageSize, 1, true);
  }, [pageSize, isIVR]);

  const handlePageChange = (tokenOrValue, direction) => {
    console.log(tokenOrValue);
    if (direction === "size") {
      const newPageSize = parseInt(tokenOrValue, 10);
      setPageSize(newPageSize);
      setCurrentPage(1);
      setLeadCache({});
      setNextPageToken(null);
      setPrevPageToken(null);
      handleApplyFilter(null, "reset", newPageSize, 1);
    } else if (direction === "next") {
      setCurrentPage((prev) => prev + 1);
      handleApplyFilter(nextPageToken, "next");
    } else if (direction === "previous") {
      setCurrentPage((prev) => Math.max(prev - 1, 1));
      handleApplyFilter(prevPageToken, "previous");
    }
  };

  const clearFilterData = () => {
    return new Promise((resolve) => {
      setSelectedStatus("");
      setSelectedLevel(null);
      setLeadSource([]);
      setSelectedUser(userId || null);
      setAttentStatus("");
      setDuration("");
      setCallStatus("");
      setStartDate(leadSource.length > 0 ? "" : todayDate.toISOString().split("T")[0]);
      setEndDate(leadSource.length > 0 ? "" : todayDate.toISOString().split("T")[0]);
      setErrors({});
      resolve();
    });
  };

  const handleClearAndApplyFilter = async () => {
    await clearFilterData();
    applyFilter();
  };

  const handleSelectionChange = (selectedIds) => {
    setSelectedRows(selectedIds);
    console.log("All selected IDs:", selectedIds);
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await teamService.getTeamName();
        const data = response.data?.teams || [];
        setTeams(data);
      } catch (error) {
        console.error("Error fetching teams:", error);
      }
    })();
  }, []);

  useEffect(() => {
    const fetchTeamUsers = async () => {
      if (!selectedTeam) {
        setUsers([]);
        return;
      }

      setIsLoading(true);
      try {
        const selected = selectedTeam || defaultTeamId;
        const response = await UserService.getDepartmentWithTeamMembers({
          teamId: selected,
          departmentNames: [managementDepartmentLabel, salesDepartmentLabel],
        });
        const data = response.data?.users || [];

        const combinedUsers = data.map((user) => ({
          id: user.value,
          name: user.label,
        }));

        const finalUsers = combinedUsers.length > 0 ? combinedUsers : [];
        setUsers(finalUsers);
      } catch (error) {
        console.error("Error fetching team users:", error);
        setUsers([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTeamUsers();
  }, [selectedTeam]);

  const handleFilterLeads = () => {
    setFilterVisible(true);
  };

  const handleStatusChange = (e) => {
    console.log(e);
    setSelectedStatus(e);
  };

  const handleSelectChange = (selectedOption) => {
    console.log(selectedOption);
    setSelectedLevel(selectedOption);
  };

  const handleTeamChange = (value) => {
    setSelectedTeam(value);
    setSelectedUser("");
  };

  const handleSearchLead = () => {
    setLeadCache({});

    if (userRole === "BOD") {
      const level = selectedLevel;
      const status = selectedStatus;
      const location = leadSource;

      const user = selectedUser;
      const start = formattedStartDate;
      const end = formattedEndDate;

      const noFiltersSelected =
        !level &&
        !status &&
        (!location || location.length === 0) &&
        !user &&
        !start &&
        !end;
      console.log("BOD");

      if (searchQuery.trim() !== "" || !noFiltersSelected) {
        handleApplyFilter();
      }
    } else {
      const level = selectedLevel;
      const status = selectedStatus;
      const location = leadSource;
      const team = selectedTeam;
      const user = selectedUser;
      const start = formattedStartDate;
      const end = formattedEndDate;

      const noFiltersSelected =
        !level &&
        !status &&
        (!location || location.length === 0) &&
        !team &&
        !user &&
        !start &&
        !end;
      console.log("Admin");

      if (searchQuery.trim() !== "" || !noFiltersSelected) {
        handleApplyFilter();
      }
    }
  };

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <FaChevronDown className="text-customGreen" />
      </components.DropdownIndicator>
    );
  };

  const getLocalDate = () => {
    const now = new Date();
    const offset = now.getTimezoneOffset();
    const localDate = new Date(now.getTime() - offset * 60 * 1000);
    return localDate.toISOString().split("T")[0];
  };

  const path = getBasePathByUserRole();

  const handleRemoveStatus = () => {
    setSelectedStatus(null);
    setCallStatus(null);
    applyFilter("status");
  };

  const handleRemoveLevel = () => {
    setSelectedLevel(null);
    applyFilter("quality");
  };

  const handleRemoveLocation = (loc) => {
    setLeadSource(null);
    applyFilter("location");
  };

  const handleRemoveTeam = () => {
    setSelectedTeam(null);
    setSelectedUser(null);
    applyFilter("team");
  };

  const handleRemoveUser = () => {
    setSelectedUser(null);
    applyFilter("user");
  };

  const handleRemoveDate = () => {
    const todayDate = new Date();
    setStartDate(todayDate.toISOString().split("T")[0]);
    setEndDate(todayDate.toISOString().split("T")[0]);
    setStartTime("00:00");
    setEndTime("23:59");
    applyFilter("startDate");
  };

  const handleAssignTeam = () => {
    if (selectedRows.length > 300) {
      showInfoToast("You can't assign more than 300 leads at a time");
      return;
    }

    navigate(`${path}/lead/reassign`, {
      state: {
        leadSourceId: selectedLeadSourceId,
        assignStatus: true,
        teamId: selectedTeam,
        leadCount: selectedRows.length,
        leadIds: selectedRows,
        teamStatus: teamToggle,
      },
    });
  };

  const handleDownloadReport = async () => {
    setLoadingDownload(true);
    try {
      const body = {
        //teamId:  selectedTeam || defaultTeamId,
        userId: selectedUser || null,
        startDate: formattedStartDate || null,
        endDate: formattedEndDate || null,
        isIvr: isIVR,
        startTime: startTime || null,
        endTime: endTime || null,
        attendanceFilter: attentStatus || null,
        durationFilter: duration || null,
      };
      const response = await CallLogService.getCallLogsSummaryDownload(body);

      if (response.status === 200) {
        const reportData = response.data?.data;
        if (!Array.isArray(reportData) || reportData.length === 0) {
          showErrorToast("No data found for the selected criteria.");
          return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Report");

        const headers = Object.keys(reportData[0]);
        worksheet.columns = headers.map((header) => ({
          header: header.trim(),
          key: header,
          width: 20,
        }));

        worksheet.getRow(1).eachCell((cell) => {
          cell.font = { bold: true, color: { argb: "FF000000" } };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "C4C6E4" },
          };
          cell.alignment = { vertical: "middle", horizontal: "center" };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });

        reportData.forEach((item) => {
          worksheet.addRow(item);
        });

        worksheet.eachRow((row, rowNumber) => {
          if (rowNumber !== 1) {
            row.height = 30;
            row.eachCell((cell) => {
              cell.alignment = { vertical: "middle", horizontal: "center" };
              cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
              };
            });
          } else {
            row.height = 60;
          }
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(
          blob,
          `Call Logs Summary Report${
            !startDate ? "" : formatDate(startDate)
          } TO ${!endDate ? "" : formatDate(endDate)}.xlsx`
        );

        showSuccessToast("Successfully downloaded");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingDownload(false);
    }
  };

  const callStatusOptions = [
    { value: null, label: "All Calls" },
    { value: "INCOMING", label: "Incoming" },
    { value: "OUTGOING", label: "Outgoing" },
    { value: "MISSED", label: "Missed" },
    { value: "DIALED", label: "RNR Calls" },
  ];

  return (
    <div className="pt-14 bg-appGrayBackground ">
      <AdminAppBar />
      <ToastContainer />
      {loadingDownload && <Loader />}
      <div className="mt-[50px] px-6">
        <div className="flex flex-col gap-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center   gap-3">
              <CustomHeading title={"Call Summary"} isIcon={true} />
              {features.ivrCalls && (
                <div className="w-full flex justify-center">
                  <div className="relative bg-slate-200 p-[4px] w-full max-w-[190px] rounded-[6px] flex justify-between items-center overflow-hidden">
                    {/* Slider background */}
                    <div
                      className="absolute top-[2px] bottom-[2px] left-[3px] w-[85px] bg-white rounded-[6px] shadow-soft-all transition-transform duration-300"
                      style={{
                        transform: isIVR
                          ? "translateX(96px)"
                          : "translateX(0px)",
                      }}
                    ></div>

                    {/* Sim Calls */}
                    <div
                      className={`w-[90px] z-10 text-center cursor-pointer py-[3px] text-sm font-medium transition-all duration-300 ${
                        !isIVR ? "text-customGreen" : "text-gray-700"
                      }`}
                      onClick={() => {
                        setIsIVR(false);
                        setCallStatus(null);
                        setSelectedLevel(null);
                        setSelectedUser(userId || null);
                        setAttentStatus(null);
                        setDuration(null);
                        setStartDate(getLocalDate());
                        setEndDate(getLocalDate());
                        setStartTime("00:00");
                        setEndTime("23:59");
                      }}
                    >
                      Sim Calls
                    </div>

                    {/* IVR Calls */}
                    <div
                      className={`w-[90px] z-10 text-center cursor-pointer py-[3px] text-sm font-medium transition-all duration-300 ${
                        isIVR ? "text-customGreen" : "text-gray-700"
                      }`}
                      onClick={() => {
                        setIsIVR(true);
                        setCallStatus(null);
                        setSelectedLevel(null);
                        setAttentStatus(null);
                        setSelectedUser(userId || null);
                        setDuration(null);
                        setStartDate(getLocalDate());
                        setEndDate(getLocalDate());
                        setStartTime("00:00");
                        setEndTime("23:59");
                      }}
                    >
                      IVR Calls
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="flex items-center gap-4">
         
              <CustomButton
                label={"Download"}
                isDisabled={
                  loadingDownload ||
                  (selectedTeam === null &&
                    selectedUser === null &&
                    !startDate &&
                    !endDate)
                }
                onClick={handleDownloadReport}
              />
            </div>
          </div>
          <div className="flex items-center">
                 <div className="flex items-center gap-5">
                {/* Status */}
                {callStatus && (
                  <div className="flex items-center gap-2 px-3 py-1 rounded-full border border-customGreen bg-white text-customGreen text-sm transition-all duration-150">
                    <span>
                      Status:{" "}
                      {
                        callStatusOptions.find(
                          (list) => list.value === callStatus
                        )?.label
                      }
                    </span>
                    <button onClick={handleRemoveStatus} className="text-sm">
                      ✖
                    </button>
                  </div>
                )}
                {/* Interest Level */}
                {selectedLevel && (
                  <div className="flex items-center gap-2 px-3 py-1 rounded-full border border-customGreen bg-white text-customGreen text-sm  transition-all duration-150">
                    <span>{selectedLevel.label}</span>
                    <button onClick={handleRemoveLevel}>✖</button>
                  </div>
                )}
                {attentStatus && (
                  <div className="flex items-center gap-2 px-3 py-1 rounded-full border border-customGreen bg-white text-customGreen text-sm  transition-all duration-150">
                    <span>Attendance: {attentStatus}</span>
                    <button
                      onClick={() => {
                        setAttentStatus(null);
                        applyFilter("attend");
                      }}
                      className="text-sm"
                    >
                      ✖
                    </button>
                  </div>
                )}
                {duration && (
                  <div className="flex items-center gap-2 px-3 py-1 rounded-full border border-customGreen bg-white text-customGreen text-sm  transition-all duration-150">
                    <span>Duration: {duration}</span>
                    <button
                      onClick={() => {
                        setDuration(null);
                        applyFilter("duration");
                      }}
                      className="text-sm"
                    >
                      ✖
                    </button>
                  </div>
                )}

                {/* Locations */}
                {leadSource?.label && (
                  <div className="flex items-center gap-2 px-3 py-1 rounded-full border border-customGreen bg-white text-customGreen text-sm  transition-all duration-150">
                    <span>{leadSource?.label}</span>
                    <button onClick={() => handleRemoveLocation()}>✖</button>
                  </div>
                )}

                {/* Team */}
                {userRole !== "BOD" && (
                  <>
                    {selectedTeam && (
                      <div className="flex items-center gap-2 px-3 py-1 rounded-full border border-customGreen bg-white text-customGreen text-sm  transition-all duration-150">
                        <span>
                          {teams.find((team) => team.teamId === selectedTeam)
                            ?.name || selectedTeam}
                        </span>
                        <button onClick={handleRemoveTeam}>✖</button>
                      </div>
                    )}
                  </>
                )}

                {/* User */}
                {selectedUser && (
                  <div className="flex items-center gap-2 px-3 py-1 rounded-full border border-customGreen bg-white text-customGreen text-sm  transition-all duration-150">
                    <span>
                      {users.find((user) => user.id === selectedUser)?.name ||
                        selectedUser}
                    </span>
                    <button onClick={handleRemoveUser}>✖</button>
                  </div>
                )}

                {/* Date Range with Time */}
                {(startDate || endDate) && (
                  <div className="flex items-center gap-2 px-3 py-1 rounded-full border border-customGreen bg-white text-customGreen text-sm  transition-all duration-150">
                    <span className="truncate">
                      {`${formatToIndianDate(
                        startDate
                      )} ${startTime} - ${formatToIndianDate(
                        endDate
                      )} ${endTime}`}
                    </span>
                    <button
                      onClick={handleRemoveDate}
                      className="flex-shrink-0"
                    >
                      ✖
                    </button>
                  </div>
                )}
              </div>
          </div>
        </div>
      </div>

      <CallLogsSummaryFilter
        visible={filterVisible}
        onHide={() => setFilterVisible(false)}
        status={status}
        selectedStatus={selectedStatus}
        handleStatusChange={handleStatusChange}
        interestLevel={interestLevel}
        selectedLevel={selectedLevel}
        handleSelectChange={handleSelectChange}
        optionLocation={optionLocation}
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        customStyles={customStyles}
        getBackgroundClass={getBackgroundClass}
        teams={teams}
        selectedTeam={selectedTeam}
        DropdownIndicator={DropdownIndicator}
        handleTeamChange={handleTeamChange}
        errors={errors}
        users={users}
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
        isLoading={isLoading}
        startDate={startDate}
        setStartDate={setStartDate}
        startType={startType}
        setStartType={setStartType}
        endDate={endDate}
        setEndDate={setEndDate}
        startTime={startTime}
        setStartTime={setStartTime}
        endTime={endTime}
        setEndTime={setEndTime}
        endType={endType}
        callStatus={callStatus}
        setCallStatus={setCallStatus}
        setEndType={setEndType}
        getLocalDate={getLocalDate}
        handleApplyFilter={applyFilter}
        clearFilters={handleClearAndApplyFilter}
        attentStatus={attentStatus}
        setAttentStatus={setAttentStatus}
        duration={duration}
        setDuration={setDuration}
      />

      <div className="mt-[40px] px-6">
        {/* Summary Statistics */}
        {/* Summary Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600 mb-1">
                  Total Records
                </p>
                <p className="text-xl font-medium text-gray-900">
                  {totalCount}
                </p>
              </div>
              <div className="p-2 bg-blue-100 rounded-lg">
                <BarChart3 className="h-6 w-6 text-blue-600" />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600 mb-1">
                  Call Count
                </p>
                <p className="text-xl font-medium text-gray-900">
                  {overallCallCount}
                </p>
              </div>
              <div className="p-2 bg-green-100 rounded-lg">
                <Phone className="h-6 w-6 text-green-600" />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600 mb-1">
                  Total Duration
                </p>
                <p className="text-lg font-medium text-gray-900">
                  {totalCallDuration}
                </p>
              </div>
              <div className="p-2 bg-purple-100 rounded-lg">
                <Clock className="h-6 w-6 text-purple-600" />
              </div>
            </div>
          </div>
        </div>

        <LeadTable
          data={leads}
          columns={columns}
          onPageChange={handlePageChange}
          selectedRows={selectedRows}
          disPlay={false}
          onSelectionChange={handleSelectionChange}
          currentPage={currentPage}
          setSearchQuery={setSearchQuery}
          handleSearchLead={handleSearchLead}
          //   handleReasignTeam={handleReasignTeam}
          handleAssignTeam={handleAssignTeam}
          searchQuery={searchQuery}
          loading={loading}
          pageSize={pageSize}
          nextPageToken={nextPageToken}
          prevPageToken={prevPageToken}
          isSearch={false}
          hasMoreLeads={hasMoreLeads}
          handleFilterLeads={handleFilterLeads}
        />
      </div>
    </div>
  );
};

export default CallLogsSummaryList;
